import React, { useState } from 'react';
import { Avatar } from 'antd';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import { InfoWraper, NavAuth, UserDropDwon } from './auth-info-style';
import Notification from './notification';
import Support from './support';
import { Popover } from '../../popup/popup';
import Heading from '../../heading/heading';
import { useAuth } from '../../../context/auth.context';
import { getProfileUrl } from '../../../utility/utility';
import { Button } from '../../buttons/buttons';
import { Modal } from 'antd';

function UserStatus() {
    const { currentUser, updateUserStatus } = useAuth();
    const [openModal, setOpenModal] = useState(false);
    return (
        <div className="user-status">
            {currentUser?.status === 'offline' && (
                <Button
                    outlined
                    icon={<FeatherIcon icon="cloud-off" size={14} />}
                    onClick={() => setOpenModal(true)}
                    style={{ color: 'lightcoral', border: 'lightcoral 1px solid' }}
                    size={'extra-small'}
                >
                    Offline
                </Button>
            )}

            {currentUser?.status === 'online' && (
                <Button
                    type="success"
                    size={'extra-small'}
                    icon={<FeatherIcon icon="cloud" size={14} />}
                    outlined
                    onClick={() => setOpenModal(true)}
                >
                    {/* Go Offline */}
                    Online
                </Button>
            )}
            <Modal
                title={currentUser?.status === 'online' ? 'Go Offline' : 'Go Online'}
                open={openModal}
                okText="Yes"
                cancelText="Close"
                onOk={() => {
                    setOpenModal(false);
                    updateUserStatus(currentUser?.status === 'online' ? 'offline' : 'online');
                }}
                onCancel={() => setOpenModal(false)}
            >
                <p>
                    Are you sure you want to go
                    {currentUser?.status === 'online' ? ' offline' : ' online'}?
                </p>
            </Modal>
        </div>
    );
}

function AuthInfo() {
    const { logout, currentUser, updateUserStats } = useAuth();
    const [logginOut, setLogginOut] = useState(false);
    const userContent = (
        <UserDropDwon>
            <div className="user-dropdwon">
                <figure className="user-dropdwon__info">
                    <img
                        style={{ width: '50px', height: '50px' }}
                        src={getProfileUrl({ currentUser })}
                        alt={currentUser.email}
                    />
                    <figcaption>
                        <Heading as="h5">
                            {currentUser?.firstName} {currentUser?.lastName}
                        </Heading>
                        <p>{currentUser?.organization?.name || 'No Organization'}</p>
                    </figcaption>
                </figure>
                <ul className="user-dropdwon__links">
                    <li>
                        <Link to="/admin/settings/my-profile">
                            <FeatherIcon icon="user" /> Profile
                        </Link>
                    </li>
                    <li>
                        <Link to="/admin/settings/notification-settings">
                            <FeatherIcon icon="bell" /> Notification Settings
                        </Link>
                    </li>
                    <li>
                        <Link to="/admin/my-subscription">
                            <FeatherIcon icon="pocket" />Subscription
                        </Link>
                    </li>
                    <li className="mobile-profile-nav">
                        <Link to="/admin/settings">
                            <FeatherIcon icon="settings" /> Settings
                        </Link>
                    </li>
                    <li className="mobile-profile-nav">
                        <Link to="/admin/calendar">
                            <FeatherIcon icon="calendar" /> Calendar
                        </Link>
                    </li>
                    {/*  <li>
                        <Link to="#">
                            <FeatherIcon icon="settings" /> Settings
                        </Link>
                    </li>
                    <li>
                        <Link to="#">
                            <FeatherIcon icon="dollar-sign" /> Billing
                        </Link>
                    </li>
                    <li>
                        <Link to="#">
                            <FeatherIcon icon="users" /> Activity
                        </Link>
                    </li>
                    <li>
                        <Link to="#">
                            <FeatherIcon icon="bell" /> Help
                        </Link>
                    </li> */}
                </ul>
                <Link
                    className="user-dropdwon__bottomAction"
                    onClick={async () => {
                        try {
                            setLogginOut(true);
                            await logout();
                            setLogginOut(false);
                        } catch (err) {
                            console.error(err);
                        }
                    }}
                    to="#"
                >
                    <Button loading={logginOut} size={'small'} type={'white'} icon={<FeatherIcon icon="log-out" />}>
                        Logout
                    </Button>
                </Link>
            </div>
        </UserDropDwon>
    );
    return (
        <InfoWraper>
            <UserStatus />
            {/* <Message /> */}
            <Notification />
            {/* <Settings /> */}
            <div className="settings">
                <Link to="/admin/settings" className="head-example">
                    <FeatherIcon icon="settings" size={20} />
                </Link>
            </div>
            {/* <Support /> */}
            <div className='calendar'>
                <Link to="/admin/calendar" className='head-example'>
                    <FeatherIcon icon={'calendar'} size={20} />
                </Link>
            </div>
            <div className="nav-author">
                <Popover placement="bottomRight" content={userContent} action="click">
                    <Link to="#" className="head-example">
                        <Avatar src={getProfileUrl({ currentUser })} />
                    </Link>
                </Popover>
            </div>
        </InfoWraper>
    );
}

export default AuthInfo;
